import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { USERS_PATHS } from '../users';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
  styleUrls: ['./users-edit.component.scss'],
  standalone: false,
})
export class UsersEditComponent implements OnInit {
  collaboratorsBreadcrumbs = [
    { text: 'Сотрудники', url: USERS_PATHS.users },
    { text: 'Редактирование сотрудника', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.collaboratorsBreadcrumbs);
  }
}
